import React from "react";
import { Form, Col, Row, Container, Button } from "react-bootstrap";
import styled from "styled-components";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { AuthService } from "../../Services/authService";
import { useAlert } from "react-alert";
import { useHistory, useParams } from "react-router-dom";

const Styles = styled.div``;

export const Forget_password = () => {
  const alert = useAlert();
  const history = useHistory();
  const params = useParams();
  const [token, settoken] = React.useState(null);

  React.useEffect(() => {
    settoken(params.token);
  }, [params]);

  return (
    <Styles>
      <div className="authContainer">
        <Container>
          <Row>
            <Col xs={12} md={5}></Col>
            <Col xs={6} md={6}>
              <div className="formContainer-1">
                <h3 className="title-text mb-5">Welcome to NRS</h3>
                <p> Please enter your new Password </p>
                <Formik
                  initialValues={{ password: "", confirm_password: "" }}
                  validationSchema={Yup.object({
                    password: Yup.string()
                      .max(12, "Must be 12 characters or less")
                      .required("Required"),
                    confirm_password: Yup.string().oneOf(
                      [Yup.ref("password"), null],
                      "Passwords must match"
                    ),
                  })}
                  onSubmit={async (values, { setSubmitting }) => {
                    values.token = token;
                    console.log(values);
                    const response = await AuthService.forgetPassword(values);
                    setSubmitting(false);
                    if (response.status === 200) {
                      alert.success("Password reset successfully");
                      history.push("/login");
                      return;
                    }

                    alert.error(response.message);
                  }}
                >
                  {({ isSubmitting, handleSubmit, handleChange, values }) => (
                    <Form onSubmit={handleSubmit}>
                      <Form.Group>
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Enter password"
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                        />
                        <ErrorMessage name="password" />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Confirm New Password</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Enter confirm password"
                          name="confirm_password"
                          value={values.confirm_password}
                          onChange={handleChange}
                        />
                        <ErrorMessage name="confirm_password" />
                      </Form.Group>

                      <Form.Group>
                        <div className="mt-5">
                          <Button
                            type="submit"
                            variant="secondary btn-action"
                            size="lg"
                            disabled={isSubmitting}
                            block
                          >
                            SUBMIT{" "}
                            {isSubmitting ? (
                              <span className="fa fa-spin fa-spinner text-white"></span>
                            ) : null}
                          </Button>
                        </div>
                      </Form.Group>
                    </Form>
                  )}
                </Formik>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Styles>
  );
};
